import React, { useState, useEffect } from 'react';
import { api } from '../api';

export default function SignupPage({ token }) {
  const [tokenInfo, setTokenInfo] = useState(null);
  const [tokenError, setTokenError] = useState('');
  const [validating, setValidating] = useState(true);
  const [done, setDone] = useState(false);

  const [form, setForm] = useState({
    name: '', username: '', password: '', confirm: '',
    email: '', phone: '', birthday: '', abn: '', bsb: '', account_number: '',
  });
  const [error, setError] = useState('');
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    api.validateSignupToken(token)
      .then(info => {
        setTokenInfo(info);
        if (info.name) setForm(f => ({ ...f, name: info.name }));
      })
      .catch(err => setTokenError(err.message))
      .finally(() => setValidating(false));
  }, [token]);

  async function handleSubmit(e) {
    e.preventDefault();
    if (form.password !== form.confirm) { setError('Passwords do not match'); return; }
    setError(''); setSaving(true);
    try {
      await api.completeSignup(token, {
        name: form.name, username: form.username, password: form.password,
        email: form.email, phone: form.phone, birthday: form.birthday,
        abn: form.abn, bsb: form.bsb, account_number: form.account_number,
      });
      setDone(true);
    } catch (err) { setError(err.message); }
    finally { setSaving(false); }
  }

  const typeLabel = {
    commissioned: 'Commissioned Contractor',
    hourly: 'Hourly Contractor',
    office_cleaner: 'Office Cleaner',
  }[tokenInfo?.type] || tokenInfo?.type || '';

  if (validating) {
    return (
      <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', background: 'linear-gradient(160deg, #1A1A1A, #3a6275)' }}>
        <div style={{ color: '#B8D4E0', fontSize: 16 }}>Validating signup link...</div>
      </div>
    );
  }

  if (tokenError) {
    return (
      <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', background: 'linear-gradient(160deg, #1A1A1A, #3a6275)', padding: 16 }}>
        <div className="card" style={{ maxWidth: 400, width: '100%', textAlign: 'center' }}>
          <div style={{ fontSize: 40, marginBottom: 8 }}>❌</div>
          <h3 style={{ margin: '0 0 8px' }}>Invalid Link</h3>
          <p style={{ color: '#6b7280', margin: '0 0 20px' }}>{tokenError}</p>
          <p style={{ color: '#9ca3af', fontSize: 13 }}>Please contact your admin for a new signup link.</p>
        </div>
      </div>
    );
  }

  if (done) {
    return (
      <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', background: 'linear-gradient(160deg, #1A1A1A, #3a6275)', padding: 16 }}>
        <div className="card" style={{ maxWidth: 400, width: '100%', textAlign: 'center' }}>
          <div style={{ fontSize: 48, marginBottom: 8 }}>🎉</div>
          <h3 style={{ margin: '0 0 8px' }}>Account Created!</h3>
          <p style={{ color: '#6b7280', margin: '0 0 20px' }}>
            Welcome to ACT's Car Detailing, <strong>{form.name}</strong>!<br />
            You can now log in with your username and password.
          </p>
          <button className="btn btn-primary" style={{ width: '100%', justifyContent: 'center' }}
            onClick={() => window.location.href = '/'}>
            Go to Login
          </button>
        </div>
      </div>
    );
  }

  return (
    <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', background: 'linear-gradient(160deg, #1A1A1A, #3a6275)', padding: 16 }}>
      <div style={{ width: '100%', maxWidth: 480 }}>
        <div style={{ textAlign: 'center', marginBottom: 24 }}>
          <img
            src={process.env.PUBLIC_URL + '/ACTS_CAR_DETAILING.png'}
            alt="ACT's Car Detailing"
            style={{ maxWidth: 220, width: '100%', objectFit: 'contain', filter: 'drop-shadow(0 4px 16px rgba(0,0,0,0.5))' }}
          />
        </div>

        <div className="card" style={{ borderTop: '4px solid #F5C518' }}>
          <h2 style={{ margin: '0 0 4px' }}>Create Your Account</h2>
          <p style={{ margin: '0 0 20px', fontSize: 13, color: '#6b7280' }}>
            {typeLabel && <>Role: <strong>{typeLabel}</strong> · </>}
            Fill in your details to get started.
          </p>

          {error && <div className="alert alert-error">{error}</div>}

          <form onSubmit={handleSubmit}>
            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 12 }}>
              <div className="form-group" style={{ marginBottom: 0, gridColumn: '1 / -1' }}>
                <label>Full Name *</label>
                <input value={form.name} onChange={e => setForm({ ...form, name: e.target.value })} required />
              </div>
              <div className="form-group" style={{ marginBottom: 0 }}>
                <label>Username *</label>
                <input value={form.username} onChange={e => setForm({ ...form, username: e.target.value })} required autoComplete="username" />
              </div>
              <div className="form-group" style={{ marginBottom: 0 }}>
                <label>Email</label>
                <input type="email" value={form.email} onChange={e => setForm({ ...form, email: e.target.value })} />
              </div>
              <div className="form-group" style={{ marginBottom: 0 }}>
                <label>Password *</label>
                <input type="password" value={form.password} onChange={e => setForm({ ...form, password: e.target.value })} required autoComplete="new-password" />
              </div>
              <div className="form-group" style={{ marginBottom: 0 }}>
                <label>Confirm Password *</label>
                <input type="password" value={form.confirm} onChange={e => setForm({ ...form, confirm: e.target.value })} required />
              </div>
              <div className="form-group" style={{ marginBottom: 0 }}>
                <label>Phone</label>
                <input value={form.phone} onChange={e => setForm({ ...form, phone: e.target.value })} />
              </div>
              <div className="form-group" style={{ marginBottom: 0 }}>
                <label>Birthday</label>
                <input type="date" value={form.birthday} onChange={e => setForm({ ...form, birthday: e.target.value })} />
              </div>

              <div style={{ gridColumn: '1 / -1', borderTop: '1px solid #f3f4f6', paddingTop: 12, marginTop: 4 }}>
                <div style={{ fontSize: 12, color: '#6b7280', fontWeight: 600, textTransform: 'uppercase', letterSpacing: 0.5, marginBottom: 10 }}>
                  Banking & ABN (for invoicing)
                </div>
              </div>

              <div className="form-group" style={{ marginBottom: 0, gridColumn: '1 / -1' }}>
                <label>ABN</label>
                <input value={form.abn} onChange={e => setForm({ ...form, abn: e.target.value })} placeholder="XX XXX XXX XXX" />
              </div>
              <div className="form-group" style={{ marginBottom: 0 }}>
                <label>BSB</label>
                <input value={form.bsb} onChange={e => setForm({ ...form, bsb: e.target.value })} placeholder="000-000" />
              </div>
              <div className="form-group" style={{ marginBottom: 0 }}>
                <label>Account Number</label>
                <input value={form.account_number} onChange={e => setForm({ ...form, account_number: e.target.value })} />
              </div>
            </div>

            <button
              type="submit"
              className="btn btn-primary"
              disabled={saving}
              style={{ width: '100%', justifyContent: 'center', marginTop: 20, padding: '12px', fontSize: 15 }}
            >
              {saving ? 'Creating account...' : 'Create My Account'}
            </button>
          </form>
        </div>
      </div>
    </div>
  );
}
